import { defineComponent as _defineComponent } from 'vue'

import { Select, Option, Switch, InputNumber } from 'element-ui'

const __default__ = {
  name: 'checklist-step-panel',
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Switch.name]: Switch,
    [InputNumber.name]: InputNumber
  }
}

import { ref, computed } from 'vue'
import axios from 'axios'
import { Auth } from 'aws-amplify'
import { API_LOCATION } from '@/api-config'
import { formatGroupTime } from '@/plugins/dates'
import { renderInstructions } from '@/util/richText'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    step: null,
    index: null,
    total: null,
    invalid: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    hideActions: { type: Boolean, default: false },
    catalog: { default: () => [] },
    tagsSaving: { type: Boolean, default: false },
    canTag: { type: Boolean, default: true },
    canCreateTicket: { type: Boolean, default: false }
  },
  emits: ["field", "toggle", "error", "add-tag", "remove-tag", "create-ticket"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'field', step: any, field: string, value: any, mode?: 'typing' | 'blur'): void
  (e: 'toggle', step: any): void
  (e: 'error', message: string): void
  (e: 'add-tag', step: any, tagId: number): void
  (e: 'remove-tag', step: any, tag: any): void
  (e: 'create-ticket', step: any): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { step: any | null, index: number, total: number, invalid: boolean, readonly: boolean, hideActions: boolean, catalog: any[], tagsSaving: boolean, canTag: boolean, canCreateTicket: boolean }





const uploading = ref(false)

// Reference images from the template snapshot; older rows only carry img_url.
const refImages = computed<string[]>(() => {
  const st = props.step
  if (!st) return []
  if (Array.isArray(st.img_urls) && st.img_urls.length) return st.img_urls
  return st.img_url ? [st.img_url] : []
})

const options = computed<string[]>(() => Array.isArray(props.step?.response_options) ? props.step.response_options : [])
const multiValue = computed<string[]>(() => {
  const v = props.step?.response_value
  if (Array.isArray(v)) return v
  try { const arr = JSON.parse(v || '[]'); return Array.isArray(arr) ? arr : [] } catch (e) { return [] }
})
const needsResponse = computed<boolean>(() => {
  const st = props.step
  if (!st || (st.response_type || 'checkbox') === 'checkbox') return false
  const v = st.response_value
  return v === null || v === undefined || String(v).trim() === '' || String(v).trim() === '[]'
})
const responseText = computed<string>(() => {
  const st = props.step
  if (!st || (st.response_type || 'checkbox') === 'checkbox') return ''
  const v = st.response_value
  if (v === null || v === undefined || v === '') return ''
  if (st.response_type === 'multiselect') {
    try { const arr = JSON.parse(v); return Array.isArray(arr) ? arr.join(', ') : String(v) } catch (e) { return String(v) }
  }
  return String(v)
})
const numberValue = computed(() => {
  const v = props.step?.response_value
  return v === null || v === undefined || v === '' ? undefined : Number(v)
})

// Free text passes 'typing' on each keystroke and 'blur' when the runner
// leaves the field; the parent saves on blur only.
function emitField(field: string, value: any, mode?: 'typing' | 'blur') {
  emit('field', props.step, field, value, mode)
}

async function authConfig() {
  const session = await Auth.currentSession()
  return { headers: { Authorization: (session as any).idToken.jwtToken } }
}

async function onPhoto(event: any) {
  const file = event.target.files && event.target.files[0]
  if (!file || !props.step) return
  uploading.value = true
  try {
    const config = await authConfig()
    const signed = await axios.post(`${API_LOCATION}upload`, { filePath: file.name, contentType: file.type }, config)
    const uploadUrl: string = signed.data
    await axios.put(uploadUrl, file, { headers: { 'Content-Type': file.type } })
    const publicUrl = uploadUrl.split('?')[0]
    emit('field', props.step, 'photo_urls', [...(props.step.photo_urls || []), publicUrl])
  } catch (err) {
    emit('error', 'The photo could not be uploaded. Try again.')
  } finally {
    uploading.value = false
    event.target.value = ''
  }
}

return { __sfc: true,props, emit, uploading, refImages, options, multiValue, needsResponse, responseText, numberValue, emitField, authConfig, onPhoto, formatGroupTime, renderInstructions }
}

})